const messageTemplates = {
  minLength: (attr, params) => `${attr} deve ter pelo menos ${params.minLength.min} caracteres`,
  required: (attr, params) => `${attr} é obrigatório.`,
}

function getLabels (attr, validator) {
  const vattr = validator[attr]
  if (!vattr.$error) return ''
  for (const type in messageTemplates) {
    if (vattr.hasOwnProperty(type) && !vattr[type]) {
      return messageTemplates[type](attr, vattr.$params)
    }
  }
  return ''
}

export default getLabels
